/**
 * Option Plus dropdown search disable
 * ---------------------------------------------------------------------------
 * The Option Plus app renders a text input (.dropdown-search) inside each
 * .dropdown-header that lets shoppers type to filter .dropdown-option items.
 * This makes that input read-only and blocks keyboard input/paste so the
 * dropdown can only be operated by clicking an option — the app's own
 * open/close and selection logic is left completely untouched.
 */
(() => {
  const CONTAINER_ID = "optionPlusvariant-container";
  const SEARCH_INPUT_SELECTOR =
    ".searchable-dropdown[data-title] .dropdown-search";

  function disableSearch(input) {
    if (input.dataset.searchDisabled) return;
    input.dataset.searchDisabled = "true";

    input.setAttribute("readonly", "readonly");
    input.setAttribute("inputmode", "none");
    input.setAttribute("aria-readonly", "true");
    input.style.caretColor = "transparent";
    input.style.cursor = "pointer";

    const block = (evt) => evt.preventDefault();
    input.addEventListener("keydown", block);
    input.addEventListener("paste", block);
    input.addEventListener("drop", block);
  }

  function disableAll(container) {
    container.querySelectorAll(SEARCH_INPUT_SELECTOR).forEach(disableSearch);
  }

  function attach(container) {
    disableAll(container);

    const observer = new MutationObserver(() => disableAll(container));
    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    const existing = document.getElementById(CONTAINER_ID);
    if (existing) {
      attach(existing);
      return;
    }

    const bodyObserver = new MutationObserver(() => {
      const container = document.getElementById(CONTAINER_ID);
      if (container) {
        bodyObserver.disconnect();
        attach(container);
      }
    });
    bodyObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
